<template>
  <div class="warehouse-list">
    <div class="warehouse-list-item"
         v-for="(item, index) in copyList"
         :key="item.id"
         @click="handleClick(item, index)"
         :class="{ 'warehouse-list-item_active': activeIndex === index }">
      {{ item.code }}
    </div>
    <el-popover
      placement="bottom-start"
      width="290"
      trigger="click"
      :visible-arrow="false"
      @hide="popoverHide"
      v-if="list.length > 10"
      popper-class="wc-warehouse-popover">
      <div class="warehouse-list-item" @click="handleExpand" slot="reference">
        {{ expandStatus ? '收起' : '更多' }}
        <img :src="ossPath + '/pages/home/icon_dropdown_c141414.png'"
             alt=""
             class="dropdown"
             :class="{ 'is-reverse': expandStatus }">
      </div>
      <div class="list-box">
        <div v-for="(item, index) in restList"
             :key="item.id"
             @click="clickRestCode(item, index)"
             :class="{ 'rest-warehouse-active': restActiveIndex === index }"
             class="rest-warehouse">
          {{ item.code }}
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "FBAWarehouseSelectNew",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    showNum: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      activeIndex: undefined,
      copyList: [],
      restList: [],
      expandStatus: false,
      restActiveIndex: undefined
    }
  },
  watch: {
    list: {
      immediate: true,
      handler(val) {
        let num = this.showNum
        if (val.length > num) {
          this.copyList = val.slice(0, num)
          this.restList = val.slice(num - 1)
        } else {
          this.copyList = val
          this.restList = []
        }
      }
    }
  },
  methods: {
    handleClick(item, index) {
      this.activeIndex = index
      this.restActiveIndex = undefined
      this.$emit('clickCode', item)
    },
    handleExpand() {
      this.expandStatus = !this.expandStatus
    },
    clickRestCode(item, index) {
      this.restActiveIndex = index
      this.activeIndex = undefined
      this.$emit('clickCode', item)
    },
    popoverHide() {
      this.expandStatus = false
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-list {
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  &-item {
    width: 80px;
    height: 30px;
    margin-right: 32px;
    padding: 0 4px;
    box-sizing: border-box;
    background: #DDDDDD;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #141414;
    line-height: 30px;
    text-align: center;
    flex-shrink: 0;
    cursor: pointer;
    transition: background-color .3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    &:last-child {
      margin-right: 0;
    }
    &_active {
      background: #FFD7C6;
      color: #FF4D01;
    }
    &:hover {
      background: #FFD7C6;
      color: #FF4D01;
    }
  }
}
.dropdown {
  width: 15px;
  height: 7px;
  transform: rotate(0);
  transition: .3s ease;
}
.is-reverse {
  transform: rotate(180deg);
}
.rest-warehouse {
  width: 33.3%;
  height: 30px;
  margin-bottom: 10px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  cursor: pointer;
  &-active {
    color: #FF4D01;
    font-weight: 600;
  }
  &:hover {
    color: #FF4D01;
    font-weight: 600;
  }
}
.list-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
<style lang="scss" scoped>
.wc-warehouse-popover.el-popper {
  height: 250px;
  padding: 15px 30px;
  overflow-y: scroll;
  box-sizing: border-box;
  left: calc((100vw - 1200px) / 2 + 1200px - 290px) !important;
}
.wc-warehouse-popover.el-popper::-webkit-scrollbar {
  width: 6px;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/FBAWarehouseSelectNew.vue